<template>
<div class="component">
    <div class="columns is-mobile is-multiline">
        <div class="column is-6-widescreen is-offset-3-widescreen is-12-mobile is-12-desktop is-12-tablet wwTitle">Ihre Projektübersicht</div>

        <div class=" column is-3-widescreen is-12-mobile has-text-right-widescreen">
            <div class="button wwButton is-large" @click="openNewProjectModal()">Neues Projekt</div>
        </div>
    </div>
    <div class="projectOverview columns is-mobile is-multiline">
        <div class="column is-3-fullhd is-4-widescreen is-6-mobile is-4-desktop is-6-tablet is-12-mobile" v-for="(project, index) in projects">
                        <div class="tile is-ancestor">
      <div class="tile is-parent is-vertical">

            <transition-group appear name="slide">
                        <projectOverviewCard :style="{ transitionDelay: getDelay(index) }" :key="project.id" @refresh="getProjects()" :project="project" />
               
            </transition-group>                </div>

        </div>
    </div></div>

    <div v-if="projects.length <1">
        <div class="subtitle">Sie sind momentan keinem Projekt zugewiesen - Erstellen Sie jetzt ein neues Projekt oder lassen Sie sich in ein bestehendes Projekt einladen.</div>
    </div>

    <newProjectModal @close="closeNewProjectModal()" @refresh="getProjects()" v-if="showProjectModal" />
    <loadingscreen v-if="isLoading" />
</div>
</template>

<script>
import projectOverviewCard from '@/components/projectOverview.vue'
import newProjectModal from '@/components/newProject.vue'

export default {
    name: 'projects',
    props: [],
    mounted: function () {
        this.isLoading = true;

        this.getProjects();
    },
    components: {
        projectOverviewCard,
        newProjectModal
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            projects: [],
            showProjectModal: false,
            isLoading: false
        }
    },
    methods: {
        getProjects() {
            this.isLoading = true;
            this.callApi("/project/all", "get").then(function (response) {
                console.log("response projects: " + response)
                this.projects = response.data.projects
                this.isLoading = false;
            }.bind(this)).catch(function (error) {
                this.isLoading = false;
            })
        },
        getDelay(index) {
            var delayBetweenItemsMS = 100;
            var delayTime = (index * delayBetweenItemsMS) / 1000
            console.log("delaytime:" + delayTime)

            return delayTime + "s"

        },
        openNewProjectModal() {
            this.showProjectModal = true;
        },
        closeNewProjectModal() {
            this.showProjectModal = false;
        }

    },
    computed: {},
}
</script>

<style scoped>
.projectOverview {
    margin-top: 5vh;
}

.slide-leave-active,
.slide-enter-active {
    transition: 1s;
    transition-timing-function: ease-out;

}

.slide-enter {
    transform: translate(100%, 0);
}

.slide-leave-to {
    transform: translate(0%, 0);
}
</style>
